export default __webpack_public_path__ + "commercial_m27e6ee.jpg";